import * as React from 'react';
import {Component, Handler, I18NString} from "../../Utils";
import {IControlSchema, createControl, IControlError, ControlErrorListItem} from "../../Controls";
import {IDispatcher } from "../extensions/Dispatcher";
import Field from '../Field';
import { isUndefined } from 'lodash'
import {Dictionary} from "../../../types/Dictionary";


export interface IGroupSchema extends IControlSchema {
   controls: Array<IControlSchema>
   disabled?: boolean;
   visible?:boolean;
}

interface Props {
    schema: IGroupSchema;
    dispatcher?: IDispatcher;
    errors: Dictionary<IControlError | undefined>,
    values: any[],
    visited: Dictionary<boolean>,
    allVisited: boolean
}


class Group extends Component<Props,{}>{

    render(){
        const controls : Array<React.ReactElement<any>> = [];
        const { dispatcher, schema } = this.props;
        const visbile = isUndefined(schema.visible) ? true : schema.visible;

        for(let ctrl of this.props.schema.controls){
            ctrl.disableNumber = this.props.schema.disableNumber;
            const element = createControl(ctrl, dispatcher, this.props.errors, this.props.values, this.props.visited, this.props.allVisited);
            controls.push(React.cloneElement(element, {key: `Group.${ctrl.id}`}))
        }

        return visbile && (
           <div>
                <Field {...this.props.schema} required={false} >
                    <span></span>
                </Field>
               {controls}
           </div>
        )
    }
}

export function createGroup(schema: IControlSchema, dispatcher: IDispatcher, errors: Dictionary<IControlError | undefined>, values: any[], visited: Dictionary<boolean>, allVisited: boolean): React.ReactElement<any> {
    return <Group schema={schema as IGroupSchema} dispatcher={dispatcher} errors={errors} values={values} visited={visited} allVisited={allVisited} />;
}
